import { Component, Input } from "@angular/core";
import { MissingRequiredFieldsInfo } from "../../../model/missing-field";

@Component({
    selector: "im-display-missing-required-fields",
    templateUrl: "./display-missing-required-fields.component.html",
    styleUrls: ["./display-missing-required-fields.component.scss"],
    standalone: false
})
export class DisplayMissingRequiredFields {
  @Input()
  public title: string = "";

  @Input()
  public missingRequiredFields: MissingRequiredFieldsInfo[] = [];
}
